
/* Stiletto Quick View: metafield galleries, desktop vertical / mobile horizontal. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.quickVariantGalleryReady === '1') return;
    var groups = Array.from(root.querySelectorAll('.quick-variant-image-group'));
    var scroll = root.querySelector('.quick-product--left-scroll');
    var right = root.querySelector('.quick-product--right');
    var dots = root.querySelector('.quick-product--dots');
    var variantJson = root.querySelector('[data-quick-variants-json]');
    if (!groups.length || !scroll || !right || !dots || !variantJson) return;

    var variants;
    try { variants = JSON.parse(variantJson.textContent); } catch (e) { return; }
    root.dataset.quickVariantGalleryReady = '1';
    var currentId = root.dataset.quickInitialVariantId;
    var activeItems = [];
    var ticking = false;
    var mobileQuery = window.matchMedia('(max-width: 719px)');

    // Start loading the first image of every color before its swatch is clicked.
    groups.forEach(function (group) {
      var firstImage = group.querySelector('img');
      if (!firstImage) return;
      firstImage.loading = 'eager';
      firstImage.setAttribute('loading', 'eager');
      firstImage.decoding = 'async';
      if (firstImage.src) {
        var preload = new Image();
        if (firstImage.srcset) preload.srcset = firstImage.srcset;
        if (firstImage.sizes) preload.sizes = firstImage.sizes;
        preload.src = firstImage.src;
      }
    });

    function activeGroup() {
      return groups.find(function (group) { return !group.hidden; });
    }

    function syncActiveDot() {
      if (!activeItems.length) return;
      var mobile = mobileQuery.matches;
      var track = mobile ? activeGroup() : scroll;
      if (!track) return;
      var center = mobile
        ? track.getBoundingClientRect().left + track.clientWidth / 2
        : scroll.getBoundingClientRect().top + scroll.clientHeight / 2;
      var closest = 0;
      var smallestDistance = Infinity;
      activeItems.forEach(function (item, i) {
        var bounds = item.getBoundingClientRect();
        var itemCenter = mobile ? bounds.left + bounds.width / 2 : bounds.top + bounds.height / 2;
        var distance = Math.abs(itemCenter - center);
        if (distance < smallestDistance) { smallestDistance = distance; closest = i; }
      });
      dots.querySelectorAll('button').forEach(function (dot, i) {
        dot.classList.toggle('active', i === closest);
        if (i === closest) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function redrawDots() {
      dots.replaceChildren();
      var group = activeGroup();
      activeItems = group ? Array.from(group.querySelectorAll('.quick-shop-images')) : [];
      if (activeItems.length < 2) return;
      activeItems.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'quick-product--dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'View image ' + (i + 1));
        dot.addEventListener('click', function () {
          if (mobileQuery.matches) {
            var group = activeGroup();
            if (group) group.scrollTo({ left: item.offsetLeft - activeItems[0].offsetLeft, behavior: 'smooth' });
          } else {
            scroll.scrollTo({ top: item.getBoundingClientRect().top - scroll.getBoundingClientRect().top + scroll.scrollTop, behavior: 'smooth' });
          }
        });
        dots.appendChild(dot);
      });
      syncActiveDot();
    }

    function showVariant(id) {
      id = String(id);
      var matching = groups.filter(function (group) {
        return group.dataset.variantIds.indexOf('|' + id + '|') !== -1;
      });
      if (!matching.length) return;
      if (currentId === id && activeGroup() === matching[0] && activeItems.length) return;
      currentId = id;
      groups.forEach(function (group) { group.hidden = matching.indexOf(group) === -1; });
      scroll.scrollTop = 0;
      matching.forEach(function (group) { group.scrollLeft = 0; });
      redrawDots();
    }

    function matchingVariant(options) {
      return variants.find(function (v) {
        return [1, 2, 3].every(function (i) { return !options[i] || v['option' + i] === options[i]; });
      });
    }

    function readOptions() {
      var options = {};
      right.querySelectorAll('select[name^="options["][data-index]').forEach(function (select) {
        options[Number(select.dataset.index.replace('option', ''))] = select.value;
      });
      return options;
    }

    function updateFromSelects() {
      var match = matchingVariant(readOptions());
      if (match) showVariant(match.id);
    }

    right.addEventListener('change', function (event) {
      if (event.target.matches('select[name^="options["]')) {
        updateFromSelects();
        requestAnimationFrame(updateFromSelects);
      }
    });

    right.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-button][data-option-value]');
      if (!btn) return;
      var wrap = btn.closest('[data-index]');
      var position = wrap && Number(wrap.dataset.index.replace('option', ''));
      if (position) {
        var options = readOptions();
        options[position] = btn.dataset.optionValue;
        var match = matchingVariant(options);
        if (match) showVariant(match.id);
      }
      requestAnimationFrame(updateFromSelects);
    });

    function queueDotUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncActiveDot(); });
    }
    scroll.addEventListener('scroll', function () {
      if (!mobileQuery.matches) queueDotUpdate();
    }, { passive: true });
    groups.forEach(function (group) {
      group.addEventListener('scroll', function () {
        if (mobileQuery.matches && !group.hidden) queueDotUpdate();
      }, { passive: true });

      // Mobile Quick View only: handle horizontal finger swipes even when a
      // nested image/link or the modal prevents native horizontal scrolling.
      var touch = null;
      // Leave vertical page scrolling native; handle horizontal motion below.
      group.style.touchAction = mobileQuery.matches ? 'pan-y' : '';
      group.addEventListener('touchstart', function (event) {
        if (!mobileQuery.matches || group.hidden || event.touches.length !== 1) return;
        var finger = event.touches[0];
        touch = {
          x: finger.clientX,
          y: finger.clientY,
          left: group.scrollLeft,
          dragging: false,
          vertical: false,
          snap: group.style.scrollSnapType
        };
      }, { passive: true });

      group.addEventListener('touchmove', function (event) {
        if (!touch || !mobileQuery.matches || event.touches.length !== 1) return;
        var finger = event.touches[0];
        var dx = finger.clientX - touch.x;
        var dy = finger.clientY - touch.y;
        if (!touch.dragging && !touch.vertical) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { touch.vertical = true; return; }
          touch.dragging = true;
          group.style.scrollSnapType = 'none';
        }
        if (!touch.dragging) return;
        if (event.cancelable) event.preventDefault();
        group.scrollLeft = touch.left - dx;
        queueDotUpdate();
      }, { passive: false });

      function finishSwipe(event) {
        if (!touch) return;
        var gesture = touch;
        touch = null;
        group.style.scrollSnapType = gesture.snap;
        if (!gesture.dragging || !mobileQuery.matches || group.hidden) return;
        var finger = event.changedTouches && event.changedTouches[0];
        var dx = finger ? finger.clientX - gesture.x : 0;
        var items = Array.from(group.querySelectorAll('.quick-shop-images'));
        if (items.length < 2) return;
        var leftOf = function (item) { return item.offsetLeft - items[0].offsetLeft; };
        var nearest = 0;
        items.forEach(function (item, index) {
          if (Math.abs(leftOf(item) - gesture.left) < Math.abs(leftOf(items[nearest]) - gesture.left)) nearest = index;
        });
        var target = Math.abs(dx) >= 35
          ? Math.max(0, Math.min(items.length - 1, nearest + (dx < 0 ? 1 : -1)))
          : nearest;
        group.scrollTo({ left: leftOf(items[target]), behavior: 'smooth' });
        queueDotUpdate();
      }
      group.addEventListener('touchend', finishSwipe, { passive: true });
      group.addEventListener('touchcancel', function () {
        if (touch) group.style.scrollSnapType = touch.snap;
        touch = null;
      }, { passive: true });
    });
    window.addEventListener('resize', function () {
      groups.forEach(function (group) { group.style.touchAction = mobileQuery.matches ? 'pan-y' : ''; });
      queueDotUpdate();
    }, { passive: true });
    showVariant(currentId);
  }

  document.addEventListener('quickview:loaded', function () {
    document.querySelectorAll('[data-quick-view-modal] .quick-product').forEach(init);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.quick-product').forEach(init);
    });
  } else {
    document.querySelectorAll('.quick-product').forEach(init);
  }
})();